/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMessagesRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/chat_messages.pb'
import {GetMessagesResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/chat_messages.pb'


export const getMessages = (request:GetMessagesRequest, options?: CashRequestOptions) => post<GetMessagesRequest, GetMessagesResponse>("/cash-app/goose-cash/v3/get-messages", request, {...options, rejectOnError: true })